export const HeaderHeight = 148+39;
export const BOTTOM_TEXT = "* Multiple responses are allowed";
export const isMobileScreen = () => window.outerWidth < 720;

export const SurveyTitles = {
  CARD_1: "Facilities",
  CARD_2: "Total number of companies in the survey",
  CARD_3: "Countries",
  CARD_4: "Industries",
  respondentCountryCount: "Facilities Locations",
  industrySurveyCount: "Industries",
  workNatureCount: "Types of Facilities",
};

export const Phases = {
  fall20: "Fall'20",
  spring21: "Spring'21",
  fall21: "Fall'21",
};

export const PreparednessTitles = {
  CARD_1: "Had emergency response plan in 2019",
  CARD_1_PHASE_3: "Had emergency response plan",
  CARD_2: "Plan was very useful in response to COVID-19",
  responsePlansPercent:
    "What type of emergency response plans did those companies have? *",
  planUsefulPercent:
    "Have these plans been useful for responding to the COVID-19 pandemic?",
};
export const FacilitiesTitles = {
  CARD_1: "More restrictive visitor policy post-COVID",
  CARD_2: "Require masks for visitors (for companies that allow visitors)",
  CARD_3: "Require masks for employees",
  CARD_4: "Provide PPE",
  employeeCount: "Number of employees at the facilities",
  employeeLocationPercentCount:
    "% of overall company employees at the facilities",
  interactionPercent: "My employees interact face to face at the facility with",
  ppeProvidedOptionsPercent:
    "What COVID related resources do companies provide to their employees? *",
  employeeCountPercentOfWF:
    "Number of employees at the facility and what % of overall company workforce they represent",
  safetyMeasuresOptionPercent:
    "What safety measures have been put in place within the facilities?",
  topIndustriesRequiringMasks: "Top 10 industries requiring masks",
  topCountriesRequiringMasks: "Top 10 countries where companies require masks",
};

export const AdjustmentsTitles = {
  CARD_1: "Top permanent action taken due to financial pressures",
  CARD_2: "Top temporary action taken due to financial pressures",
  adjustmentsPercent: "What actions have you taken? *",
  tempAdjustmentsLastPercent:
    "How long do you expect temporary actions taken to last?",
};

export const ComingBackTitles = {
  CARD_1: "Negative attitude towards returning",
  CARD_2: "Positive attitude towards returning post-pandemic",
  CARD_3: "Primary concern about coming back",
  expectionWorkforceOnsite:
    "When do you expect your workforce to come back to work onsite?",
  empReturnDecisionPercent:
    "Who will decide when the employees are coming back onsite?",
  infoSourceForReopenPercent:
    "What sources of information are you using to inform your reopening plans?",
  milestonesForWFReturnPercent:
    "What milestones need to occur in order for you to return workforce to work onsite? *",
  workerReturnPercentBucket:
    "On what date did you begin to bring your workers back?",
  physicalReturnOptionsPercent:
    "What is the overall workforce’s opinion about returning back to the workplace?",
  WorkerReturnConcernsPercent: "What are worker's concerns about returning? *",
  workersReturn:
    "What % of workers returned / are expected to return in the first phase?",
  haveWorkersReturnedBackToSitePercent: "Have workers returned to on-site?",
  reasonForReinstatingPrecautionsPercent: "If you reduced COVID-19 workplace precautions, what would cause it to get reinstated? *",
  whenDidYouAskWorkersToWorkRemotely: "When did you ask workers to work remotely/come back?",
};
export const RemoteWorkTitles = {
  CARD_1: "Required workforce to work from home",
  CARD_2: "Who made the decision to go remote?",
  CARD_3: "Highest % of remote employees during pandemic",
  CARD_4: "Current % of remote employees",
  CARD_5: "Reduced COVID-19 workplace safety precautions",
  CARD_6: "Average % of workers returned",
  calendar:
    "Over a 6 month period, when did employers ask workers to begin staying at home",
  remoteDecisionMakerPercent: "Who made the decision to go remote?",
};

export const OverviewTitles = {
  CARD_1: "Test their workers",
  CARD_2: "Main reason companies do not test",
  CARD_3: "Test for viral infection",
  CARD_4: "Test for antibodies",
  CARD_5: "Test for both",
  CARD_6: "Perform environmental/surveillance testing",
  reasonsCompanyNotTestingPercent: "Reasons why companies choose not to test *",
  futureTestingPlansPercent: "Future plans for companies who aren’t testing",
};

export const FutureOfWorkOverviewTitles = {
  CARD_1: "Intend to allow employees to work from home full-time through 2021",
  CARD_2: "Intend to offer flexible or expanded work from home policies post-pandemic",
  CARD_3: "Believe Employees should be in the office at least 20 hrs a week",
  CARD_4: "Main challenge in returning employees to physical work environment",
  AnticipatedWorkEnvironmentPercent:
    "Describe your anticipated work environment in the future",
  ReasonsForEMPsToBeInOfficePercent:
    "Reasons why companies think employees should be in the office at least 20 hrs a week",
  FuturePlansForPhysicalOfficePercent:
    "Companies future plans for their physical workspace",
  ChallengeToReturnPercent:
    "Main challenge in returning employees to physical work environment"
};

export const FutureOfWorkChallengesTitles = {
  CARD_1: "Top concern for organization",
  CARD_2: "% of companies where employees resigned from organization due to COVID-19 workplace policies",
  CARD_3: "% of companies where employees were terminated from organization due to COVID-19 workplace policies",
  topConcernForOrganizationPercent:
    "What are the top concerns organizations have?",
  percentResignationDueToWorkplacePolicies:
    "Have employees resigned due to COVID-19 workplace policies (vaccination, testing, remote work, etc) or lack of thereof?",
  workPoliciesResultingInResignation:
    "COVID-19 workplace policies that resulted in employees leaving *",
  workPoliciesResultingInTermination:
    "COVID-19 workplace policies that resulted in employees being terminated *",
  percentTerminationDueToWorkplacePolicies:
    "Have employees been termminated due to COVID-19 workplace policies (vaccination, testing, remote work, etc) or lack of thereof?",
};

export const ViralTitles = {
  CARD_1: "Companies that test for viral infection",
  CARD_2: "Companies with mandatory testing",
  CARD_3: "Direct to indirect cost ratio for viral tests",
  CARD_5: "Companies that test asymptomatic workers",
  CARD_6: "Companies that test at least once a week",
  CARD_7: "% of workers tested",
  CARD_8: "% of workers that tested positive",
  viralTestTypeAdministered: "Types of viral test administered",
  companyPlansForTesting: "Companies plans for testing the workforce *",
  testingPolicyChangeForVaccinatedEmployees: "Does testing policy change for vaccinated employees?",
  preferredMethodToReceiveCovidTestAtHome: "Preferred method to receive at home COVID-19 test results",
  VITestFrequencyCount: "How frequently are you performing viral testing?",
  VITestFuturePlanPercent: "What are the future plans for viral testing?",
  highestPriorityForVITestingPercent:
    "Which group of workers takes priority for viral testing?",
  consequenceForNoVITestPercent:
    "What are the consequences for lack of compliance if testing is mandatory? *",
  whereWorkersTestedForVIPercent: "Where are your workers being tested? *",
  whoDoesVITestPercent: "Who administers viral tests to your workers? *",
  whoPaysForVITestPercent: "Who pays for viral testing?",
  VITestResultTimePercent: "How soon after the test do you expect results?",
  factorsForVITestProviders:
    "What was the most important factor in you choosing a testing provider?",
  VITestResultReceiverPercent: "Who receives workers positive results? *",
  wherePositiveVIestsStoredPercent:
    "Where is data about positive viral test cases stored?",
};

export const AntibodyTitles = {
  CARD_1: "Companies that test for antibodies",
  CARD_2: "Companies with mandatory testing",
  CARD_3: "% of workers that tested positive",
  CARD_4: "Direct to indirect cost ratio for antibodies test",
  CARD_6: "% of workers tested",
  ABTestFreqPercent: "How frequently are you performing antibody testing?",
  futureABPlansPercent: "What are the future plans for antibody testing? ",
  highestPriorityForTestingPercent:
    "Which group of workers takes priority for antibody testing? *",
  consequenceForNoTestPercent:
    "What are the consequences for lack of compliance if antibody testing is mandatory? *",
  whereWorkersTestedForABPercent: "Where are your workers being tested? *",
  whoDoesABTestPercent: "Who administers antibody tests to your workers? *",
  whoPaysForABTestPercent: "Who pays for antibody testing?",
  ABTestResultReceiverPercent: "Who receives workers positive results? *",
  wherePositiveABTestsStoredPercent:
    "Where is data about positive antibody test cases stored?",
};

export const FinancialImpactTitles = {
  CARD_1: "Direct to indirect cost ratio for viral tests",
  CARD_2: "Direct to indirect cost ratio for antibodies test",
  CARD_3:
    "Over 25% increase in operating costs (excluding testing) due to the pandemic",
  chart1: "Not including testing, what one-time costs have you incurred? *",
  chart2:
    "Compared to a year ago, what % increase in your monthly operating costs will be COVID-19 related – excluding testing?",
};

export const ContactTracingOverview = {
  CARD_1: "Contact tracing implemented",
  CARD_2: "Contact tracing mandatory",
  CARD_3: "Trace workers’ contacts outside of workplace ",
  CARD_4: "Main challenge of contact tracing",
  whichContactTracing: "Which contact tracing measures have been put in place?",
  mainChallengesContactTracing: "Main challenges for contact tracing *",
  traceWorkerContactsPercent:
    "Are you tracing worker contacts outside of the workplace?",
  empResponseForTracingPercent:
    "How did workers respond to contact tracing measures?",
};

export const ContactTracingProviders = {
  CARD_1: "Companies collaborating with other entities",
  CARD_2:
    "Have measures in place to ensure data is interoperable between entities",
  chart1: "Which entities do you collaborate with to contact trace?",
  chart2: "Which entities supply human contact tracers that are being used?",
  chart3:
    "What is your protocol for employees without access to contact tracing app if you use one?",
};

export const ContactTracingProtocols = {
  CARD_1: "Ask workers to sign liability waivers",
  CARD_2: "Have protocols in place if cluster of infections are emerging",
  CARD_3: "Have threshold at which facility will be shut down",
  chart1:
    "Who in the company is informed when worker tests positive for infection? *",
  chart2:
    "What are the protocols for employees who might have come into contact with a positive person at work?",
  chart3:
    "What types of company resources are given to workers who test positive or come in contact with someone who tests positive?",
  chart4:
    "What requirements does COVID positive worker need to meet to return to workplace? *",
};

export const VaccinationTitles = {
  CARD_1: "Offered incentives to employees to be vaccinated",
  CARD_2: "Would allow vaccinations to be administered to employees at their facility",
  CARD_3: "Plan to change safety mitigation measures once broad vaccination is achieved",
  CARD_4: "Proof of vaccination from employees is",
  CHART_1: "Companies' policies for employees regarding COVID-19 vaccination",
  CHART_2: "What are the consequences for lack of compliance with vaccination policy? *",
  CHART_3: "Types of incentives offered to get vaccinated *",
};

export const EmployeeBeingTitles = {
  CARD_1: "Engagement",
  CARD_2: "Productivity",
  CARD_3: "Morale",
  CARD_4: "Burnout",
  CARD_5: "Mental Health Concerns",
  CHART_1: "How employee wellbeing changed during the pandemic compared to pre-pandemic",
  CHART_2: "Mental Health",
  CHART_3: "Companies increased the use of available company resources related to mental health",
};